// return the user data from the session storage
export const aPIURL=()=>
{
  let Str="";
          switch (process.env.NODE_ENV) //Auto
          {
          //case "development":
          //  Str="https://localhost:9080/api/";
          //  break;
          //case "uat":
           // Str = "http://192.168.1.22:2060/api/"; 
           // break;
          case "production":
            Str ="https://api3.avtbharat.com/api/";//https://api.avtbharat.com/api/";//"https://api3.avtbharat.com/api/";// 
           // break; 
          default:
            Str = "https://api3.avtbharat.com/api/"; 
        }
   //const Str ="https://api.avtbharat.com/api/";  //for production
   //const Str = "http://192.168.1.22:2060/api/"; 
   //const Str="https://localhost:9080/api/";
   //const Str = "version"; 
   return Str;
}
export const auTHURL=()=>
{
  
  let Str="";
          switch (process.env.NODE_ENV) //Autoprocess.env.NODE_ENV
          {
          //case "development":
            //Str="https://localhost:9082/Authorization/";
            //break;
          //case "uat":
           // Str = "http://192.168.1.22:2059/Authorization/"; 
          // break;
          case "production":
            Str = "https://userauth3.avtbharat.com/Authorization/";//"https://userauth2.avtbharat.com:88/Authorization/";//"https://userauth.avtbharat.com/Authorization/";
          //  break;
          default:
            Str = "https://userauth3.avtbharat.com/Authorization/"; 
        }
    //const Str = "https://userauth.avtbharat.com/Authorization/"; //for production
    // Str ="https://userauth2.avtbharat.com:88/Authorization/";//for production Server 2
    //const Str = "http://192.168.1.22:2059/Authorization/"; 
    
    return Str;
}

// "https://login.avtbharat.com/"; //for production Server1 
//   "https://login3.avtbharat.com/";//for production server2
//const Str = "http://192.168.1.22:2058/"; //for UAT  
// const Str ="http://localhost:3000/"; //for development      
export const websiteUrl=()=>
  {
     const Str ="https://login3.avtbharat.com/";
      return Str;
  }
  
export const pdfUrl=()=>
  {
       //const Str ="https://login.avtbharat.com/Profile/Report/"; //for production  "https://login3.avtbharat.com/Profile/Report/";//
       
       const Str ="https://login3.avtbharat.com/Profile/Report/";
       //const Str = "http://192.168.1.22:2058/Profile/Report/"; //for UAT  
        
      return Str;
  }
export const profileImageUrl=()=>
  {
       //const Str ="https://login.avtbharat.com/Profile/"; //for production   "https://login3.avtbharat.com/Profile/";//"    
       const Str ="https://login3.avtbharat.com/Profile/";
       //const Str = "http://192.168.1.22:2058/Profile/Report/"; //for UAT
       //const Str = "http://localhost:8062/Profile/"; //for development
      return Str;
  }


export const getUser = () => {
  
    
    const userStr = sessionStorage.getItem('user');
   
    if (userStr) 
    { 
      //return userStr.substring(1,userStr.length-1);
      return JSON.parse(userStr);    
      
    }
    else 
    {
         return null;
    }
    
  }
   
  // return the token from the session storage
  export const getToken = () => 
  {
    const usertokenStr = sessionStorage.getItem('token');
   
    if (usertokenStr) 
    { 
      
      return JSON.parse(usertokenStr);    
      
    }
    else 
    {
         return null;
    }
    
  }
  export const getUserId = () => 
  {
    const userIdStr = sessionStorage.getItem('userID');
   
    if (userIdStr) 
    { 
      
      return JSON.parse(userIdStr);    
      
    }
    else 
    {
         return null;
    }
    
  }
  export const getUserRole = () => 
  {
    const userRoleStr = sessionStorage.getItem('userRole');
   
    if (userRoleStr) 
    { 
      
      return JSON.parse(userRoleStr);    
      
    }
    else 
    {
         return null;
    }
    
  }
  export const getLoginName = () => 
  {
    const loginnameStr = sessionStorage.getItem('loginName');
   
    if (loginnameStr) 
    { 
      
      return JSON.parse(loginnameStr);    
      
    }
    else 
    {
         return null;
    }
    
  }
  export const getCustomerTypeId = () =>
  {
    const customerTypeIdStr = sessionStorage.getItem('customerTypeId');
    if (customerTypeIdStr)
    {
          return JSON.parse(customerTypeIdStr);
    }
    else
    {
         return null;
    }
  }
  // remove the token and user from the session storage
  export const removeUserSession = () =>
  {
    localStorage.setItem('loginstatus','0');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('userRole');
    sessionStorage.removeItem('userID');
    sessionStorage.removeItem('loginName');
    sessionStorage.removeItem('customerTypeId');
    window.localStorage.clear();
  }
  // set the token and user from the session storage
  export const setUserSession = (token, user,userRole,userID,name,customerTypeId) => {
    //sessionStorage.setItem
    localStorage.setItem('loginstatus','1');
    sessionStorage.setItem('token', token);
    sessionStorage.setItem('user', JSON.stringify(user));
    sessionStorage.setItem('userRole', JSON.stringify(userRole));
    sessionStorage.setItem('userID', JSON.stringify(userID));
    sessionStorage.setItem('loginName', JSON.stringify(name));
    sessionStorage.setItem('customerTypeId',JSON.stringify(customerTypeId));
  }

  export const checkLoginstatus=()=>
  {
         if(localStorage.getItem('loginstatus')==='1')
         {
            return true;

         }
        return false;
        
  }
  

  /*
  export const setBaseUrl = () => {
    sessionStorage.setItem('baseUrl', "https://localhost:9088/");
  }

  export const getBaseUrl = () => 
  {
        const baseUrl = sessionStorage.getItem('baseUrl');  
        return baseUrl; 
  }
  */